// extracted by mini-css-extract-plugin
module.exports = {"rating":"zj","numberOfStars":"Aj"};